import React from 'react'
import {
  Notice,
  Icon,
  InfoOutlined,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

const icon = <Icon svgComponent={InfoOutlined} color="attention" />

function InfoAlert() {
  return (
    <div className="discounts__info-alert">
      <Notice useSSRIcon ssrIcon={icon} type="attention">
        <div className="cgt-ml-10 cgt-mt-10">
          Designers who participate in discount programs can see up to 50% more
          total revenue on average.
        </div>
      </Notice>
    </div>
  )
}

export default InfoAlert
